import { OpcionSpEnum } from "src/app/utilerias/enums/OpcionSpEnum";

export class Base {
    pCodRetorno: string;
    pMensaje: string;
    pOpcion: OpcionSpEnum;
    pTotalItems:number;
}
